'use client';
import { lazy, type ComponentProps } from 'react';
export type * from "/tmp/build-510/overrides/components/product/detail/product-images.tsx";
const Deferred0 = lazy(() => import("@eliadmin/page-island-original/a86568cb7a42").then(m => ({ default: m.ProductImages })));
const Island0 = ((props: NonNullable<ComponentProps<typeof import("/tmp/build-510/overrides/components/product/detail/product-images.tsx").ProductImages>>) => <Deferred0 {...props} />) as typeof import("/tmp/build-510/overrides/components/product/detail/product-images.tsx").ProductImages;
export { Island0 as ProductImages };
